module.exports = __webpack_public_path__ + "static/media/sort-dsc.cea8d628.svg";